import React from "react";
import ReactGA from "react-ga4";

const useAnalyticsEventTracker = (category="Udimu-test") => {
  const eventTracker = (action = "test action", label = "test label") => {
    ReactGA.event({category, action, label});
  }
  return eventTracker;
}


const ProductArray = [
  "1990-98", "Mid 1990", "2000-04", "2007-09", "2011-13", "2014-15", "2019", "2020"
]

const ScenarArray = [
  "Open IQOS", "Close IQOS", "Open Stick", "Closing Stick", "Charging IQOS", "Using IQOS"
]

export default useAnalyticsEventTracker;
export {ProductArray, ScenarArray}